<template>
  <div>
    <Sidenav
      :is-sidebar-active.sync="isSidebarActive"
      :is-add.sync="isAdd"
      :item-edit="itemEdit"
      :user-options="userOptions"
      @refetch-data="refetchData"
    />
    <b-row class="pt-2 pb-1">
      <b-col cols="12" class="d-flex align-items-center">
        <BreadcrumbMenu/>
      </b-col>
    </b-row>

    <toastification-loading-content ref="loadingToast"/>

    <!-- Table Container Card -->
    <b-card-group deck class="mx-2 mt-1">
      <b-card class="m-0" no-body>
        <div class="m-2">
          <!-- Table Top -->
          <b-row>
            <!-- Per Page -->
            <b-col
              cols="12"
              md="6"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label class="text-capitalize">{{ $t("table.show") }}</label>
              <v-select
                v-model="perPage"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="perPageOptions"
                :clearable="false"
                class="per-page-selector d-inline-block mx-50"
                data-cy="per-page-selector"
              />
              <label class="text-capitalize">{{ $t("table.entries") }}</label>
            </b-col>

            <!-- Search -->
            <b-col cols="12" md="6">
              <div class="d-flex align-items-center justify-content-end">

                <b-form-input
                  v-model="searchQuery"
                  class="d-inline-block mr-1"
                  :placeholder="$t('table.search')"
                  data-cy="search-input"
                />

                <b-button
                  variant="primary"
                  @click="openAdd()"
                  v-if="$can('create', 'DistributionList')"
                >
                  <span class="text-nowrap text-capitalize">
                    {{
                      `${$t("actions.add")} ${$t("distribution_list.table_distribution.title")}`
                    }}
                  </span>
                </b-button>

              </div>
            </b-col>


          </b-row>
        </div>

        <b-table
          ref="refListTable"
          class="position-relative test-table"
          :items="fetchList"
          responsive
          :fields="tableColumns"
          primary-key="id"
          :sort-by.sync="sortBy"
          show-empty
          :empty-text="$t('no_record_found')"
          :sort-desc.sync="isSortDirDesc"
        >

          <!-- <template #table-busy> :busy="isBusy" (en el b-table) :class="{ 'fade-in': !isBusy }"
            <div class="text-center my-3">
              <b-icon
                icon="broadcast"
                animation="spin"
                font-scale="4"
                variant="primary"
              />
            </div>
          </template> -->

          <template #head()="data">
            <span> {{ $tc(data.label, 2) }}</span>
          </template>

          <template #head(actions)="data">
            <span> {{ $tc(data.label, 2) }}</span>
          </template>

          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <div class="actions-cell">
              <b-dropdown variant="link" no-caret :right="$store.state.appConfig.isRTL">
                <template #button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="16"
                    class="align-middle text-body"
                  />
                </template>

                <b-dropdown-item
                  @click="openEdit(data.item)"
                  v-if="$can('update', 'DistributionList')"
                >
                  <feather-icon icon="EditIcon"/>
                  <span class="align-middle ml-50 text-capitalize">
                    {{ $t("actions.edit") }}
                  </span>
                </b-dropdown-item>

                <b-dropdown-item
                  @click="confirmDelete(data.item.id)"
                  v-if="$can('delete', 'DistributionList')"
                >
                  <feather-icon icon="TrashIcon"/>
                  <span class="align-middle ml-50 text-capitalize">
                    {{ $t("actions.delete") }}
                  </span>
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </template>

          <!--<template #cell(emails)="data">
            <div class="d-flex flex-wrap">

              <template v-if="data.item.emails && data.item.emails.length">
                <b-badge
                  v-for="email in data.item.emails.slice(0, 3)"
                  :key="email"
                  variant="light-info"
                  class="mr-50 mb-25"
                >
                  {{ email }}
                </b-badge>
              </template>

              <b-badge
                v-else
                variant="light-secondary"
                class="mr-50 mb-25"
              >
                {{ $t("distribution_list.table_distribution.noemails") }}
              </b-badge>
            </div>
          </template>-->

        </b-table>

        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted text-capitalize">{{
                  $t("table.showing", {
                    from: dataMeta.from,
                    to: dataMeta.to,
                    of: dataMeta.of,
                  })
                }}</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <Pagination
                :totalList="totalList"
                :currentPage="currentPage"
                @updatePagination="update"
                :perPage="perPage"
                data-cy="pagination"
              >
              </Pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </b-card-group>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BTable,
  BButton,
  BDropdown,
  BDropdownItem,
  BPagination,
} from "bootstrap-vue";
import vSelect from "vue-select";
import {ref} from "@vue/composition-api";
import useList from "./useList";
import {useToast} from "vue-toastification/composition";
import ToastificationContent
  from "@core/components/toastification/ToastificationContent.vue";
import store from "@/store";
import {useUtils as useI18nUtils} from "@core/libs/i18n";
import BreadcrumbMenu from "@/components/BreadcrumbMenu.vue";
import ToastificationLoadingContent
  from "@core/components/toastification/ToastificationLoadingContent.vue";
import Pagination from "@/components/Pagination.vue";
import Sidenav from "./Sidenav.vue";

export default {
  components: {
    Sidenav,
    BreadcrumbMenu,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    vSelect,
    ToastificationLoadingContent,
    Pagination,
  },

  setup(_, context) {
    //start pagination
    const update = (data) => {
      currentPage.value = data;
    };
    //end pagination

    const loadingToast = ref(null);
    const action = ref("list");
    const isSidebarActive = ref(false);
    const itemEdit = ref({});
    const isAdd = ref(false);
    const {t} = useI18nUtils();
    const toast = useToast();
    const translations = {
      "distribution_list.table_distribution.successful_delete": t(
        "distribution_list.table_distribution.successful_delete"
      ),
      "distribution_list.table_distribution.error_delete": t("distribution_list.table_distribution.error_delete"),
    };
    const {
      fetchList,
      tableColumns,
      perPage,
      currentPage,
      totalList,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refListTable,
      refetchData,
      userOptions,
      // isBusy,
    } = useList();

    const confirmDelete = function (id) {
      const self = this;
      const storeInner = store;
      this.$swal({
        title: context.parent.$i18n.t("messages.delete.title"),
        text: context.parent.$i18n.t("messages.delete.body"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: context.parent.$i18n.t("actions.delete"),
        cancelButtonText: context.parent.$i18n.t("actions.cancel"),
        customClass: {
          confirmButton: "btn btn-primary text-capitalize",
          cancelButton: "btn btn-outline-danger ml-1 text-capitalize",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          storeInner
          storeInner.dispatch("distribution_list/delete", id)
            .then((response) => {
              toast({
                component: ToastificationContent,
                props: {
                  title:
                    response.message ||
                    translations["distribution_list.table_distribution.successful_delete"],
                  icon: "CheckIcon",
                  variant: "success",
                },
              });
              self.refetchData();
            })
            .catch((response) => {
              toast(
                {
                  component: ToastificationContent,
                  props: {
                    title:
                      response.response.data.message ||
                      translations["distribution_list.table_distribution.error_delete"],
                    icon: "AlertTriangleIcon",
                    variant: "danger",
                  },
                },
                {
                  timeout: 10000,
                }
              );
            });
        }
      });
    };

    const openAdd = () => {
      isSidebarActive.value = true;
      isAdd.value = true;
    };

    const openEdit = (item) => {
      isSidebarActive.value = true;
      itemEdit.value = item;
      isAdd.value = false;
    };

    return {
      isSidebarActive,
      isAdd,
      itemEdit,
      openEdit,
      openAdd,
      confirmDelete,
      loadingToast,
      action,
      fetchList,
      tableColumns,
      perPage,
      currentPage,
      totalList,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refListTable,
      refetchData,
      update,
      userOptions,
      // isBusy,
    };
  },
};
</script>

<style lang="scss" scoped>
.col-actions {
  width: 60px;
  max-width: 60px;
  text-align: center;
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.actions-cell {
  width: 20px;
  display: flex;
  justify-content: center;
}

@keyframes fadeInTable {
  from {
    opacity: 0;
    transform: translateY(3px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.test-table.fade-in {
  animation: fadeInTable 0.6s ease forwards;
}

</style>
